import { Box, FormHelperText, Radio, Theme, Typography } from "@material-ui/core";
import { observer } from "mobx-react";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    option: {
      display: "inline-flex",
      justifyContent: "center",
      alignItems: "center",
      paddingRight: '8px',
      cursor: "pointer",
      marginRight: '16px',
    },
    label: {
      marginBottom: '8px'
    },
    labelError: {
      color: theme.palette.error.main,
    },
  })
);

export type RadioGroupOption = {
  label: string;
  value: string;
  checked: boolean;
  onClick: () => void;
};

type RadioGroupProps = {
  label: string;
  options: RadioGroupOption[];
  error?: string;
};

export const RadioGroup = observer(({
  options,
  label,
  error,
}: RadioGroupProps) => {

  const classes = useStyles();

  return (
    <Box>
      <Typography variant="body1" className={clsx(classes.label, error && classes.labelError)}>{label}</Typography>
      <Box mb={1} fontSize={16} display={"flex"}>
        {options.map(option => (
          <Box
            onClick={() => option.onClick()}
            className={clsx(classes.option)}>
            <Radio
              checked={option.checked}
              onChange={() => { }}
              value={option.value}
              name="bg-radio"
              color="primary"
            />
            <Box component={"span"} ml={1}>{option.label}</Box>
          </Box>
        ))}
      </Box>
      {error && <FormHelperText error>{error}</FormHelperText>}
    </Box>
  );
});
